import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "tab",
    "pickedInstructorToken",
    "radio",
    "pupilId",
  ];

  connect() {

  }


  async showQuickLook(event) {
    event.preventDefault();
    const el = event.currentTarget;
    const pupilToken =
      el.getAttribute("data-driving-school-student-adjust-balance-pupil-id") ||
      this.data.get("pupilId");
    const feeGuid = el.getAttribute("data-driving-school-student-adjust-balance-fee-guid");
    await this.refreshQuickLook(pupilToken, feeGuid);
  }

  // Extract the fetch logic into a separate method
  async refreshQuickLook(pupilToken, feeGuid) {
    const quickViewElement = document.querySelector("#school-dashboard-lesson-quick-look");
    quickViewElement.classList.remove("u-hidden");
    
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    let url = `/schools/pupils/${pupilToken}/adjust-balance/quick-look`;
    if (feeGuid) {
      url += `?fee_guid=${encodeURIComponent(feeGuid)}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    });

    if (response.ok) {
      const responseBody = await response.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(responseBody, "text/html");
      const template = xmlDoc.querySelector("template");
      const targetElement = document.getElementById("school_lesson_quick_look");

      if (template && targetElement) {
        targetElement.innerHTML = "";
        targetElement.appendChild(template.content.cloneNode(true));
      }
    }
  }

  toggleErrorPanel(show, errorMessage) {
    const errorSection = document.getElementById("error-section");
    const errorList = document.getElementById("errors-list");
  
    if (show) {
      errorSection.classList.remove("u-hidden");
      errorList.textContent = errorMessage || "An error occurred";
    } else {
      errorSection.classList.add("u-hidden");
      errorList.textContent = "";
    }
  }

  scrollToTop() {
    const quicklook = document.getElementById("balance-quicklook");
    
    if (quicklook) {
      quicklook.scrollTop = 0;
    }
  }

  removePaymentClick(event) {
    this.scrollToTop();
  
    event.preventDefault();
    const confirmed = confirm("Are you sure you want to remove this payment?");
    if (!confirmed) {
      return
    }

    const balanceIdData = event.currentTarget.getAttribute("data-balance-id");
    const pupilTokenData = event.currentTarget.getAttribute("data-pupil-token");

    if (balanceIdData && pupilTokenData) {
      this.removePayment(balanceIdData, pupilTokenData);
    } else {
      alert("Something went wrong, please try again.");
    }

  }

  async removePayment(balanceId, pupilToken) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
  
    const response = await fetch(`/schools/pupils/${pupilToken}/adjust-balance/remove-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ balance_id: balanceId })
    });

    const responseData = await response.json();

    if (response.ok) {
      if (responseData.success) {
        // Refresh the quick look section with the pupilToken we already have
        await this.refreshQuickLook(pupilToken);
        window.dispatchEvent(new CustomEvent("driving-school-student-payments-v2:refresh"));
      } else {
        alert("Failed to remove payment: " + (responseData.error || "Unknown error."));
      }
    } else {
      alert(responseData.error || "Failed to remove payment. Please try again.");
    }
  }
}
